import { computed } from 'vue'

import { usePostHog } from '@/common/composables/usePostHog'

// Feature flag centralization
export function useFeatureFlags() {
  const posthog = usePostHog()

  const isSalesReportsEnabled = computed(() =>
    posthog.isFeatureEnabled('automatic-sales-reporting'),
  )

  const isNewImageCropperApiEnabled = computed(() =>
    posthog.isFeatureEnabled('new_image_cropper_api'),
  )

  const isPerformancePromoteDrawerEnabled = computed(() =>
    posthog.isFeatureEnabled('performance-promote-drawer'),
  )

  const isResidencyPromoteDrawerEnabled = computed(() =>
    posthog.isFeatureEnabled('residency-promote-drawer'),
  )

  const isMarketingAnalyticsEnabled = computed(() =>
    posthog.isFeatureEnabled('marketing-analytics'),
  )

  const isProgressIndicatorVisible = computed(
    () => posthog.getInstance()?.getFeatureFlag('checkout-progress-indicator') === 'bar-visible',
  )

  const isIntercomChatEnabled = computed(() => posthog.isFeatureEnabled('intercom-chat'))

  const isGiftCardRedemptionEnabled = computed(() =>
    posthog.isFeatureEnabled('gift-card-redemption'),
  )

  const isShowsV3Enabled = computed(() => posthog.isFeatureEnabled('shows-v3'))

  const isContinuousServiceEnabled = computed(() =>
    posthog.isFeatureEnabled('continuous_service_enabled'),
  )

  const isWaitlistSoldOutPerformanceEnabled = computed(() =>
    posthog.isFeatureEnabled('waitlist-sold-out-performance'),
  )

  const isLiveDashboardEnabled = computed(() => posthog.isFeatureEnabled('live-dashboard'))

  const isCancelPerformanceEnabled = computed(() => posthog.isFeatureEnabled('cancel-performance'))

  const isLegalLinkCheckoutEnabled = computed(() => posthog.isFeatureEnabled('legal-link-checkout'))

  const isImageCropSettingsEnabled = computed(() => posthog.isFeatureEnabled('image-crop-settings'))

  const isNewGuestUiCalendarEnabled = computed(() =>
    posthog.isFeatureEnabled('new-guest-ui-calendar'),
  )

  return {
    isSalesReportsEnabled,
    isNewImageCropperApiEnabled,
    isPerformancePromoteDrawerEnabled,
    isResidencyPromoteDrawerEnabled,
    isMarketingAnalyticsEnabled,
    isProgressIndicatorVisible,
    isIntercomChatEnabled,
    isGiftCardRedemptionEnabled,
    isShowsV3Enabled,
    isWaitlistSoldOutPerformanceEnabled,
    isContinuousServiceEnabled,
    isLiveDashboardEnabled,
    isCancelPerformanceEnabled,
    isLegalLinkCheckoutEnabled,
    isImageCropSettingsEnabled,
    isNewGuestUiCalendarEnabled,
  }
}
